"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  markIllegible: function(documentPage) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/document_pages/" + documentPage.id + "/illegible",
      type: "POST",
      contentType: "application/json"
    }).then(DataStoreService.responseHandler, _.identity));
  },
  markHidden: function(documentPage, isHidden) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/document_pages/" + documentPage.id + "/hidden",
      data: JSON.stringify({ hidden: isHidden }),
      type: "POST",
      contentType: "application/json"
    }).then(DataStoreService.responseHandler, _.identity));
  }
};
